import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cf-wrapper flex-col" }
const _hoisted_2 = {
  class: "bold",
  notranslate: ""
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "flex-col sig-wrapper"
}
const _hoisted_5 = { class: "flex-row sig-instr" }
const _hoisted_6 = { class: "form-flex" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.form.Title), 1),
    _createElementVNode("div", {
      class: "cf-question",
      notranslate: "",
      innerHTML: _ctx.form.Question
    }, null, 8, _hoisted_3),
    (_ctx.getSignature)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createTextVNode(" `` ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "bold" }, "Your signature is required", -1)),
            _createElementVNode("button", {
              class: "clear-sig",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearSigPad()))
            }, "Clear")
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("canvas", { id: "sigCanvas" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "form-submit-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getSignature ? _ctx.captureSignature() : _ctx.$emit('onAgree', _ctx.form.ConsentFormQuestionKey))),
        disabled: _ctx.disableSubmit
      }, _toDisplayString(_ctx.getSignature ? 'Submit' : 'I agree to these terms'), 9, _hoisted_7)
    ])
  ]))
}